import { create } from 'zustand';
import type { AdminDailyAnalyticsData } from '../domain/adminAnalytics';
import type { AdminOwnerDailyAnalyticsData } from '../domain/adminOwnerAnalytics';

interface AdminAnalyticsState {
  externalData: AdminDailyAnalyticsData | null;
  ownerData: AdminOwnerDailyAnalyticsData | null;
  setExternalData: (data: AdminDailyAnalyticsData) => void;
  setOwnerData: (data: AdminOwnerDailyAnalyticsData) => void;
}

export const useAdminAnalyticsStore = create<AdminAnalyticsState>((set) => ({
  externalData: null,
  ownerData: null,
  setExternalData: (externalData) => set({ externalData }),
  setOwnerData: (ownerData) => set({ ownerData }),
}));
